/**
 * Turns a story's `cover_svg` markup into a `data:` URL usable as Media
 * Session artwork (lock screen / control center). `encodeURIComponent` +
 * the `charset=utf-8` data URL form (rather than base64/`btoa`, which chokes
 * on the accented French text some covers embed) — same trick as CSS
 * `background-image: url("data:image/svg+xml,...")` inlining.
 *
 * iOS's Media Session artwork support for SVG specifically is unverified
 * here (no physical device in this environment) — Safari has historically
 * been pickier about non-raster artwork than Chrome/Android. Real covers
 * are simple flat-color SVGs (see src/mocks/covers/*.svg), which is the
 * case most likely to render even if some iOS versions are stricter.
 */
export function svgCoverToDataUrl(svg: string | null | undefined): string | undefined {
  if (!svg) return undefined;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
